import React from 'react';
import { MessageCircle } from 'lucide-react';
import { ChatAvatar } from '../header/ChatAvatar';
import { getBrowserLanguage } from '../../../utils/languageUtils';
import { useAgentStore } from '../../../store/agentStore';
import { motion } from 'framer-motion';

interface ChatButtonProps {
  onClick: () => void;
}

export function ChatButton({ onClick }: ChatButtonProps) {
  const language = getBrowserLanguage();
  const { currentAgent } = useAgentStore();
  
  const buttonText = language === 'nl' 
    ? `Chat met ${currentAgent.name}` 
    : `Chat with ${currentAgent.name}`;

  return (
    <motion.button
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      whileHover={{ scale: 1.05 }}
      whileTap={{ scale: 0.95 }}
      onClick={onClick}
      className="flex items-center gap-2 bg-gradient-to-r from-brand-600 to-brand-500 text-white px-5 py-3 rounded-full shadow-lg hover:from-brand-700 hover:to-brand-600 transition-all"
    >
      <ChatAvatar />
      <MessageCircle className="w-5 h-5" />
      <span className="font-medium">{buttonText}</span>
    </motion.button>
  );
}